module.exports = __webpack_public_path__ + "img/company_map.5b89975d.png";